import { athleteSettingsApi } from '../services/athleteSettingsApi';

const RETURN_ATHLETE_KEY = 'vo2_garmin_return_athlete';

export function readGarminReturnAthlete(): number | null {
  try {
    const id = Number(sessionStorage.getItem(RETURN_ATHLETE_KEY));
    return Number.isSafeInteger(id) && id > 0 ? id : null;
  } catch { return null; }
}

export function clearGarminReturnAthlete(): void {
  try { sessionStorage.removeItem(RETURN_ATHLETE_KEY); } catch { /* storage unavailable */ }
}

/** Keep OAuth in the PWA's current context; no popup or user-activation dependency. */
export async function redirectToGarmin(athleteId: number): Promise<void> {
  const response = await athleteSettingsApi.getGarminAuthUrl(athleteId);
  const url = response.data.data;
  if (typeof url !== 'string' || !url.trim()) throw new Error('Garmin auth URL missing');
  const destination = new URL(url);
  if (destination.protocol !== 'https:' && destination.protocol !== 'http:') {
    throw new Error('Invalid Garmin auth URL');
  }
  // A full-page round trip must retain the coach's selected athlete.
  try { sessionStorage.setItem(RETURN_ATHLETE_KEY, String(athleteId)); } catch { /* storage unavailable */ }
  window.location.assign(destination.href);
}
